import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { TrashButton } from '@checkmarx/cx-ui';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import DeleteDialog from '../../portal/dialogs/deleteDialog';
import ErrorDialog from '../../portal/dialogs/errorDialog';

@inject('translationsStore', 'teamMembersStore', 'teamsStore') @observer
export default class RemoveTeamMemberButton extends Component {

    state = {
        openDeleteDialog: false,
        openErrorDialog: false
    };

    openDeleteDialog = () => {

        this.setState({ 
            openDeleteDialog: true
        }); 
    }

    closeDeleteDialog = () => {

        this.setState({ 
            openDeleteDialog: false
        }); 
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    removeUser = () => {

        this.props.teamMembersStore.removeTeamUser(this.props.teamsStore.selectedTeamId, this.props.userId)
            .then(() => {
                
                this.closeDeleteDialog();
                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('TEAM_MEMBER_REMOVED_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({level, message});
            })
            .catch(() => {
                
                this.closeDeleteDialog();
                this.openErrorDialog();
            });
    }

    getUserFullName() {

        let userFullName = this.props.teamMembersStore.teamUsers.filter((u) => u.id == this.props.userId);

        if(userFullName && userFullName.length > 0) {

            return userFullName[0].firstName + ' ' + userFullName[0].lastName;
        }
    }

    getTeamName() {

        let teamName = this.props.teamsStore.teams.filter((t) => t.id == this.props.teamsStore.selectedTeamId);

        if(teamName && teamName.length > 0) {

            return teamName[0].name;
        }
    }

    render() {

        const userFullName = this.getUserFullName();
        const teamName = this.getTeamName();
        const message = this.props.translationsStore.translate('MEMBER_WILL_REMOVE_FROM_TEAM')
                            .replace('{username}', userFullName)
                            .replace('{teamname}', teamName);

        return(
            <div className='remove-user-column'>
                <TrashButton onClick={this.openDeleteDialog} />
                <DeleteDialog 
                    show={this.state.openDeleteDialog}
                    onConfirm={this.removeUser}
                    deleteButtonText={this.props.translationsStore.translate('REMOVE')}
                    cancelText={this.props.translationsStore.translate('CANCEL')}                                
                    closeDeleteDialog={this.closeDeleteDialog}
                    titleText={this.props.translationsStore.translate('REMOVE_MEMBER_FROM_TEAM')}
                    contentText={message} 
                    inProgress={this.props.teamMembersStore.removingUserFromTeam}/>
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.props.teamMembersStore.removeTeamUserErrorMessage} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/removeTeamMemberButton/index.jsx